export function commissionAmount(price: string, rate: string): string {
  const p = price.trim().replace(/^[￥¥]/, '').replace(/元$/, '').trim()
  const r = rate.trim().replace(/[%％]$/, '').trim()
  if (!/^\d+(\.\d+)?$/.test(p) || !/^\d+(\.\d+)?$/.test(r)) return ''
  const amount = Number(p) * Number(r) / 100
  return Number.isFinite(amount) ? `${Number(amount.toFixed(2))}元` : ''
}

export function recommendationFor(title: string): string {
  const name = title.trim().slice(0, 32)
  return name ? `${name}，日常好物轻松选，按需挑选更省心。` : ''
}

export function cleanProductTitle(value: string): string {
  return value.replace(/\s+/g, ' ').trim()
    .replace(/\s*[-_—|]*\s*(?:tmall\.com(?:天猫)?|天猫Tmall\.com|天猫超市|淘宝网(?:\s*[-—].*)?)\s*$/i, '')
    .replace(/\s+(?:(?:已售|月销|销量|付款人数)\s*[\d.]+(?:万|千)?\+?|可开发票|多人评价|超\s*[\d.]+(?:万|千)?\+?\s*人加购).*$/i, '')
    .trim()
}

export function cleanShopName(value: string): string {
  const normalized = value.replace(/\s+/g, ' ').trim()
  const namedShop = normalized.match(/^(.{2,50}?(?:官方旗舰店|旗舰店|专卖店|专营店|企业店|工厂店|店铺|店))(?=\s*\d|\s*VIP|\s*好评率|\s*平均|\s*客服|$)/i)
  return (namedShop?.[1] || normalized.split(/(?:\d(?:\.\d+)?\s*VIP|好评率|平均\d|客服平均)/i)[0]).trim()
}

export function normalizeSalesText(value: string): string {
  const match = value.replace(/\s+/g, '').match(/(?:日销|今日已售|已售|月销|销量|付款人数)[:：]?([\d.]+(?:万|千)?\+?)/)
  return match ? `热销 ${match[1]}` : ''
}

// Runs only on the detail page where the user clicks the bookmark. No network requests.
function collectProduct() {
  if (!/(^|\.)(taobao\.com|tmall\.(?:com|hk)|tb\.cn)$/.test(location.hostname)) {
    alert('请先打开淘宝、天猫或天猫国际商品详情页，再点击这个书签。'); return
  }
  const meta = (key: string) => document.querySelector<HTMLMetaElement>(`meta[property="${key}"],meta[name="${key}"]`)?.content || ''
  const text = (selector: string) => document.querySelector<HTMLElement>(selector)?.innerText?.trim() || ''
  const cleanTitle = (value: string) => value.replace(/\s+/g, ' ').trim().replace(/\s*[-_—|]*\s*(?:tmall\.com(?:天猫)?|天猫Tmall\.com|天猫超市|淘宝网(?:\s*[-—].*)?)\s*$/i, '').replace(/\s+(?:(?:已售|月销|销量|付款人数)\s*[\d.]+(?:万|千)?\+?|可开发票|多人评价|超\s*[\d.]+(?:万|千)?\+?\s*人加购).*$/i, '').trim()
  const cleanShop = (value: string) => {
    const normalized = value.replace(/\s+/g, ' ').trim()
    const named = normalized.match(/^(.{2,50}?(?:官方旗舰店|旗舰店|专卖店|专营店|企业店|工厂店|店铺|店))(?=\s*\d|\s*VIP|\s*好评率|\s*平均|\s*客服|$)/i)
    return (named?.[1] || normalized.split(/(?:\d(?:\.\d+)?\s*VIP|好评率|平均\d|客服平均)/i)[0]).trim()
  }
  const isProductTitle = (value: string) => value.length >= 4 && value.length <= 160 && !/^(?:尺码信息|商品参数|规格参数|用户评价|累计评价|买家评价|宝贝评价|商品评价|商品详情|图文详情|配送|服务|优惠|选择颜色|选择尺码|主图|商品图片)(?:[·:：\s].*)?$/i.test(value)
  const mainImage = document.querySelector<HTMLImageElement>('#J_ImgBooth, [class*="mainPic"] img, [class*="mainImage"] img, [class*="PicGallery"] img, [class*="picGallery"] img')
  const image = meta('og:image') || mainImage?.currentSrc || mainImage?.src || ''
  const titleNodes = Array.from(document.querySelectorAll<HTMLElement>('[class*="ItemTitle"], [class*="itemTitle"], [class*="item-title"], h1')).map(el => cleanTitle(el.innerText))
  const titleCandidates = [cleanTitle(meta('og:title')), ...titleNodes, cleanTitle(mainImage?.alt || ''), cleanTitle(document.title)].filter(isProductTitle).sort((left, right) => right.length - left.length)
  const title = titleCandidates[0] || ''
  const rawShop = text('[class*="ShopInfo"] [class*="title"], [class*="shopInfo"] [class*="title"], [class*="shopName"] a, [class*="shopName"], [class*="ShopName"], .shop-name, .tb-shop-name a')
  const data = {
    title,
    shopName: cleanShop(rawShop),
    imageUrl: image ? new URL(image, location.href).href : '',
  }
  const payload = JSON.stringify(data, null, 2)
  const area = document.createElement('textarea')
  area.value = payload
  area.style.cssText = 'position:fixed;left:-9999px;top:0'
  document.body.append(area); area.focus(); area.select()
  const copied = document.execCommand('copy')
  area.remove()
  const oldTip = document.getElementById('__xuandan_copy_tip__')
  if (oldTip) oldTip.remove()
  const tip = document.createElement('div')
  tip.id = '__xuandan_copy_tip__'
  tip.textContent = copied ? '标题、店铺和主图已复制' : '复制失败，请检查浏览器剪贴板权限'
  tip.style.cssText = `position:fixed;z-index:2147483647;right:24px;top:24px;padding:13px 18px;border-radius:8px;background:${copied ? '#28a86b' : '#d94b60'};color:white;box-shadow:0 6px 24px #0004;font:14px sans-serif`
  document.body.append(tip); setTimeout(() => tip.remove(), 3500)
}

export const productBookmark = `javascript:(${collectProduct.toString()})();`
